import { createSelector } from '@reduxjs/toolkit';
import { selectPrice } from 'shared/selectors/jsonQuery';
import { commarize, getUnit, deunit, round } from 'shared/utils/number';
import { selectDefaultPriceLabel } from './selectDefaultPriceLabel';

export const selectPriceLabel = createSelector([selectPrice, selectDefaultPriceLabel], (priceRange, defaultLabel) => {
  if (!priceRange) {
    return defaultLabel;
  }

  const { gte: min = null, lte: max = null } = priceRange;

  let priceMin: string | null = null;
  const priceMax: string | null = max !== null ? commarize(max) : null;

  if (min !== null && max !== null) {
    if (min === 0 && max === 0) {
      return defaultLabel;
    }

    const minUnit = getUnit(min);
    const maxUnit = getUnit(max);
    const minWithUnit = min > max || minUnit !== maxUnit;

    const minDeunited = deunit(min, minUnit);

    if (minDeunited >= 100 && maxUnit - minUnit === 1) {
      priceMin = round(minDeunited / 1000, 1)
        .toString()
        .replace(/\./g, ',');
    } else {
      priceMin = commarize(min, !minWithUnit);
    }
  } else if (min !== null) {
    priceMin = commarize(min);
  }

  if (priceMin && !priceMax) {
    return `от ${priceMin} \u20bd`;
  } else if (!priceMin && priceMax) {
    return `до ${priceMax} \u20bd`;
  } else if (priceMin && priceMax) {
    return `${priceMin} - ${priceMax} \u20bd`;
  }

  return defaultLabel;
});
